var eServicesLastSearch = "";

jQuery(document).ready(function($) {

	if(!($('.client-side-search').length))
		return;

	$("input#inputClientSideSearch").on("input", function(e){
		var search = $(this).val();
		if(search != null)
			search = $.trim(search);
		if(search==null || search.length < 1)
		{
			$('.clientSideSearchEl').show();
			updateCountedObjects();
			return;
		}
		else if(search == eServicesLastSearch){
			//Nothing new, do nothing.
			return;
		}
		else{
			//console.log("Filtering on: "+$(this).val());
			$('.clientSideSearchEl').hide();

			var selector = "";
			$.each($(this).data(),function(k,v){
				var fixed = k.replace(/([A-Z])/g, function($1, p1, pos){return (pos > 0 ? "-" : "") + $1.toLowerCase();});
				if(fixed.startsWith("searchable"))
					selector+=".clientSideSearchEl[data-"+fixed+"*='"+search+"'], ";
			});

			if(selector.endsWith(", "))
				selector = selector.substring(0, selector.length - 2); //Remove the trailing ", ".

			$(selector).show();
			updateCountedObjects();
		}
	});
});

